var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.status == 1)?_c('div',[_c('span',{staticClass:"badge bdg-new"},[_vm._v("Contacted")])]):_vm._e(),(_vm.status == 2)?_c('div',[_c('span',{staticClass:"badge bdg-submitted"},[_vm._v("Converted")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }